const C = "#A08060";

export const CoconutTree = ({ className = "" }) => (
  <svg viewBox="0 0 100 180" fill="none" className={className} aria-hidden="true">
    <path d="M48 180V75" stroke={C} strokeWidth="3" strokeLinecap="round"/>
    <path d="M52 180V78" stroke={C} strokeWidth="2.5" strokeLinecap="round"/>
    <path d="M50 76C50 76 25 50 12 45" stroke={C} strokeWidth="2" strokeLinecap="round"/>
    <path d="M50 72C50 72 78 40 95 35" stroke={C} strokeWidth="2" strokeLinecap="round"/>
    <path d="M48 74C48 74 35 30 22 15" stroke={C} strokeWidth="2" strokeLinecap="round"/>
    <path d="M52 70C52 70 72 25 88 10" stroke={C} strokeWidth="2" strokeLinecap="round"/>
    <path d="M50 68C50 68 48 20 45 2" stroke={C} strokeWidth="2" strokeLinecap="round"/>
    <ellipse cx="42" cy="67" rx="5" ry="6" stroke={C} strokeWidth="1.5"/>
    <ellipse cx="58" cy="63" rx="5" ry="6" stroke={C} strokeWidth="1.5"/>
    <ellipse cx="50" cy="60" rx="4" ry="5" stroke={C} strokeWidth="1.5"/>
  </svg>
);

export const Coconut = ({ className = "" }) => (
  <svg viewBox="0 0 60 60" fill="none" className={className} aria-hidden="true">
    <circle cx="30" cy="32" r="20" stroke={C} strokeWidth="2"/>
    <circle cx="24" cy="26" r="2.5" fill={C}/>
    <circle cx="36" cy="26" r="2.5" fill={C}/>
    <circle cx="30" cy="35" r="2.5" fill={C}/>
    <path d="M18 18C22 8 38 8 42 18" stroke={C} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export const Crab = ({ className = "" }) => (
  <svg viewBox="0 0 100 80" fill="none" className={className} aria-hidden="true">
    <ellipse cx="50" cy="45" rx="22" ry="16" stroke={C} strokeWidth="2"/>
    <path d="M28 42C18 35 10 28 8 22" stroke={C} strokeWidth="2" strokeLinecap="round"/>
    <path d="M8 22C6 18 10 16 14 20" stroke={C} strokeWidth="2" strokeLinecap="round"/>
    <path d="M72 42C82 35 90 28 92 22" stroke={C} strokeWidth="2" strokeLinecap="round"/>
    <path d="M92 22C94 18 90 16 86 20" stroke={C} strokeWidth="2" strokeLinecap="round"/>
    <path d="M32 55L22 65" stroke={C} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M38 58L30 70" stroke={C} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M45 59L42 72" stroke={C} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M55 59L58 72" stroke={C} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M62 58L70 70" stroke={C} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M68 55L78 65" stroke={C} strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="42" cy="40" r="2" fill={C}/>
    <circle cx="58" cy="40" r="2" fill={C}/>
  </svg>
);

export const Fish = ({ className = "" }) => (
  <svg viewBox="0 0 100 55" fill="none" className={className} aria-hidden="true">
    <path d="M72 28C72 14 54 4 34 9C14 14 4 24 4 28C4 32 14 42 34 47C54 52 72 42 72 28Z" stroke={C} strokeWidth="2"/>
    <path d="M72 28L92 14L92 42L72 28Z" stroke={C} strokeWidth="2" strokeLinejoin="round"/>
    <circle cx="22" cy="24" r="3" fill={C}/>
    <path d="M38 18C43 23 43 33 38 38" stroke={C} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M48 20C52 24 52 32 48 36" stroke={C} strokeWidth="1.2" strokeLinecap="round"/>
  </svg>
);

export const FishingBoat = ({ className = "" }) => (
  <svg viewBox="0 0 140 100" fill="none" className={className} aria-hidden="true">
    <path d="M15 60C15 60 25 78 70 78C115 78 125 60 125 60" stroke={C} strokeWidth="2" strokeLinecap="round"/>
    <line x1="70" y1="60" x2="70" y2="12" stroke={C} strokeWidth="2" strokeLinecap="round"/>
    <path d="M70 15L108 42L70 52" stroke={C} strokeWidth="1.5" strokeLinejoin="round"/>
    <path d="M5 88C25 82 50 82 75 88S120 92 140 88" stroke={C} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M0 95C22 90 48 90 70 95S115 98 140 95" stroke={C} strokeWidth="1" strokeLinecap="round"/>
  </svg>
);

export const Fisherman = ({ className = "" }) => (
  <svg viewBox="0 0 120 140" fill="none" className={className} aria-hidden="true">
    <circle cx="60" cy="18" r="10" stroke={C} strokeWidth="2"/>
    <path d="M60 28V80" stroke={C} strokeWidth="2"/>
    <path d="M60 45L35 70" stroke={C} strokeWidth="2" strokeLinecap="round"/>
    <path d="M60 45L85 35" stroke={C} strokeWidth="2" strokeLinecap="round"/>
    <path d="M85 35C95 30 105 35 110 50C112 58 108 65 100 68C90 72 78 68 75 60" stroke={C} strokeWidth="1.5" strokeLinecap="round" strokeDasharray="3 3"/>
    <path d="M60 80L40 120" stroke={C} strokeWidth="2" strokeLinecap="round"/>
    <path d="M60 80L80 120" stroke={C} strokeWidth="2" strokeLinecap="round"/>
    <path d="M30 130C50 125 70 125 90 130" stroke={C} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export const Fisherwoman = ({ className = "" }) => (
  <svg viewBox="0 0 100 150" fill="none" className={className} aria-hidden="true">
    <circle cx="50" cy="16" r="10" stroke={C} strokeWidth="2"/>
    <path d="M50 26V55" stroke={C} strokeWidth="2"/>
    <path d="M35 35L65 35" stroke={C} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M50 55L35 100" stroke={C} strokeWidth="2" strokeLinecap="round"/>
    <path d="M50 55L65 100" stroke={C} strokeWidth="2" strokeLinecap="round"/>
    <path d="M40 55C40 55 42 50 50 50C58 50 60 55 60 55" stroke={C} strokeWidth="1.5"/>
    <ellipse cx="75" cy="60" rx="18" ry="12" stroke={C} strokeWidth="2"/>
    <path d="M65 55C70 48 80 48 85 55" stroke={C} strokeWidth="1.5"/>
    <path d="M68 60L70 55" stroke={C} strokeWidth="1" strokeLinecap="round"/>
    <path d="M75 60L75 54" stroke={C} strokeWidth="1" strokeLinecap="round"/>
    <path d="M82 60L80 55" stroke={C} strokeWidth="1" strokeLinecap="round"/>
    <path d="M50 45L65 52" stroke={C} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export const Beach = ({ className = "" }) => (
  <svg viewBox="0 0 200 80" fill="none" className={className} aria-hidden="true">
    <path d="M0 50C30 42 60 38 100 40C140 42 170 48 200 50" stroke={C} strokeWidth="2"/>
    <circle cx="160" cy="15" r="12" stroke={C} strokeWidth="1.5"/>
    <path d="M160 15L170 5M160 15L150 5M160 15L172 15M160 15L148 15M160 15L168 25M160 15L152 25" stroke={C} strokeWidth="1"/>
    <path d="M25 50V15" stroke={C} strokeWidth="2" strokeLinecap="round"/>
    <path d="M25 18C25 18 10 5 5 0" stroke={C} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M25 18C25 18 40 5 48 0" stroke={C} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M25 22C25 22 15 12 8 8" stroke={C} strokeWidth="1.2" strokeLinecap="round"/>
    <path d="M0 65C20 60 45 58 70 62S130 68 160 65S190 62 200 65" stroke={C} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M0 75C25 70 55 68 85 72S145 78 175 75L200 75" stroke={C} strokeWidth="1" strokeLinecap="round"/>
  </svg>
);

export const OceanWaves = ({ className = "" }) => (
  <svg viewBox="0 0 400 50" fill="none" className={className} aria-hidden="true">
    <path d="M0 25C20 12 40 12 60 25S100 38 120 25S160 12 180 25S220 38 240 25S280 12 300 25S340 38 360 25S400 12 400 25" stroke={C} strokeWidth="2" strokeLinecap="round"/>
    <path d="M0 40C25 30 50 30 75 40S125 50 150 40S200 30 225 40S275 50 300 40S350 30 375 40L400 40" stroke={C} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M0 15C15 8 30 8 45 15S75 22 90 15S120 8 135 15S165 22 180 15" stroke={C} strokeWidth="1" strokeLinecap="round"/>
  </svg>
);

export const Seashell = ({ className = "" }) => (
  <svg viewBox="0 0 70 70" fill="none" className={className} aria-hidden="true">
    <path d="M35 8C18 8 6 25 6 42C6 55 16 65 35 65C54 65 64 55 64 42C64 25 52 8 35 8Z" stroke={C} strokeWidth="2"/>
    <path d="M35 8C35 8 30 28 30 45" stroke={C} strokeWidth="1.2"/>
    <path d="M35 8C35 8 40 28 40 45" stroke={C} strokeWidth="1.2"/>
    <path d="M35 8C35 8 22 22 17 40" stroke={C} strokeWidth="1.2"/>
    <path d="M35 8C35 8 48 22 53 40" stroke={C} strokeWidth="1.2"/>
  </svg>
);

export const Starfish = ({ className = "" }) => (
  <svg viewBox="0 0 70 70" fill="none" className={className} aria-hidden="true">
    <path d="M35 5L41 24L62 18L50 35L68 48L45 45L35 65L25 45L2 48L20 35L8 18L29 24Z" stroke={C} strokeWidth="2" strokeLinejoin="round"/>
    <circle cx="35" cy="35" r="5" stroke={C} strokeWidth="1.5"/>
  </svg>
);

export const Hibiscus = ({ className = "" }) => (
  <svg viewBox="0 0 80 80" fill="none" className={className} aria-hidden="true">
    <ellipse cx="40" cy="22" rx="11" ry="17" stroke={C} strokeWidth="1.5"/>
    <ellipse cx="40" cy="22" rx="11" ry="17" stroke={C} strokeWidth="1.5" transform="rotate(72 40 40)"/>
    <ellipse cx="40" cy="22" rx="11" ry="17" stroke={C} strokeWidth="1.5" transform="rotate(144 40 40)"/>
    <ellipse cx="40" cy="22" rx="11" ry="17" stroke={C} strokeWidth="1.5" transform="rotate(216 40 40)"/>
    <ellipse cx="40" cy="22" rx="11" ry="17" stroke={C} strokeWidth="1.5" transform="rotate(288 40 40)"/>
    <circle cx="40" cy="40" r="6" stroke={C} strokeWidth="1.5"/>
    <line x1="40" y1="40" x2="40" y2="52" stroke={C} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export const Mango = ({ className = "" }) => (
  <svg viewBox="0 0 60 80" fill="none" className={className} aria-hidden="true">
    <path d="M30 8C15 12 6 28 6 48C6 62 16 72 30 72C44 72 54 62 54 48C54 28 45 12 30 8Z" stroke={C} strokeWidth="2"/>
    <path d="M30 8C30 8 28 2 35 0" stroke={C} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M30 20V60" stroke={C} strokeWidth="1" strokeLinecap="round"/>
    <path d="M30 35L20 45" stroke={C} strokeWidth="1" strokeLinecap="round"/>
    <path d="M30 35L40 45" stroke={C} strokeWidth="1" strokeLinecap="round"/>
  </svg>
);

export const ArecaNut = ({ className = "" }) => (
  <svg viewBox="0 0 40 70" fill="none" className={className} aria-hidden="true">
    <ellipse cx="20" cy="40" rx="14" ry="22" stroke={C} strokeWidth="2"/>
    <path d="M10 30C14 28 26 28 30 30" stroke={C} strokeWidth="1" strokeLinecap="round"/>
    <path d="M8 38C12 36 28 36 32 38" stroke={C} strokeWidth="1" strokeLinecap="round"/>
    <path d="M8 46C12 44 28 44 32 46" stroke={C} strokeWidth="1" strokeLinecap="round"/>
    <path d="M20 18C20 18 18 8 22 2" stroke={C} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export const SindhudurgFort = ({ className = "" }) => (
  <svg viewBox="0 0 200 100" fill="none" className={className} aria-hidden="true">
    <path d="M10 80L10 50L25 50L25 40L40 40L40 50L55 50L55 45L70 45L70 50L85 50L85 35L100 30L115 35L115 50L130 50L130 45L145 45L145 50L160 50L160 40L175 40L175 50L190 50L190 80" stroke={C} strokeWidth="2"/>
    <rect x="15" y="55" width="8" height="10" stroke={C} strokeWidth="1"/>
    <rect x="35" y="55" width="8" height="10" stroke={C} strokeWidth="1"/>
    <rect x="55" y="52" width="6" height="8" stroke={C} strokeWidth="1"/>
    <rect x="130" y="52" width="6" height="8" stroke={C} strokeWidth="1"/>
    <rect x="155" y="55" width="8" height="10" stroke={C} strokeWidth="1"/>
    <rect x="175" y="55" width="8" height="10" stroke={C} strokeWidth="1"/>
    <path d="M90 50L95 42L100 38L105 42L110 50" stroke={C} strokeWidth="1.5"/>
    <path d="M0 85C40 78 80 76 120 80C160 84 200 82 200 85" stroke={C} strokeWidth="1.5"/>
    <path d="M95 50L95 65L105 65L105 50" stroke={C} strokeWidth="1.5"/>
  </svg>
);

export const Temple = ({ className = "" }) => (
  <svg viewBox="0 0 80 120" fill="none" className={className} aria-hidden="true">
    <path d="M40 5L55 30L25 30Z" stroke={C} strokeWidth="2" strokeLinejoin="round"/>
    <path d="M40 5L40 0" stroke={C} strokeWidth="2" strokeLinecap="round"/>
    <rect x="22" y="30" width="36" height="8" stroke={C} strokeWidth="1.5"/>
    <rect x="18" y="38" width="44" height="6" stroke={C} strokeWidth="1.5"/>
    <rect x="25" y="44" width="30" height="45" stroke={C} strokeWidth="2"/>
    <rect x="35" y="65" width="10" height="24" stroke={C} strokeWidth="1.5"/>
    <rect x="15" y="89" width="50" height="6" stroke={C} strokeWidth="1.5"/>
    <path d="M10 95L70 95" stroke={C} strokeWidth="2"/>
    <path d="M5 100L75 100" stroke={C} strokeWidth="1.5"/>
  </svg>
);

export const Lighthouse = ({ className = "" }) => (
  <svg viewBox="0 0 60 120" fill="none" className={className} aria-hidden="true">
    <path d="M22 110L25 40L35 40L38 110" stroke={C} strokeWidth="2"/>
    <rect x="20" y="35" width="20" height="10" rx="2" stroke={C} strokeWidth="2"/>
    <path d="M25 35L28 20L32 20L35 35" stroke={C} strokeWidth="1.5"/>
    <circle cx="30" cy="14" r="6" stroke={C} strokeWidth="2"/>
    <path d="M24 14L10 10" stroke={C} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M36 14L50 10" stroke={C} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M24 12L12 5" stroke={C} strokeWidth="1" strokeLinecap="round"/>
    <path d="M36 12L48 5" stroke={C} strokeWidth="1" strokeLinecap="round"/>
    <path d="M26 55L34 55" stroke={C} strokeWidth="1"/>
    <path d="M25 70L35 70" stroke={C} strokeWidth="1"/>
    <path d="M24 85L36 85" stroke={C} strokeWidth="1"/>
    <path d="M15 115C25 112 35 112 45 115" stroke={C} strokeWidth="1.5"/>
  </svg>
);

export const PaddyField = ({ className = "" }) => (
  <svg viewBox="0 0 200 60" fill="none" className={className} aria-hidden="true">
    <path d="M0 40C10 35 20 38 30 40S50 35 60 40S80 45 90 40S110 35 120 40S140 45 150 40S170 35 180 40S200 45 200 40" stroke={C} strokeWidth="1.5"/>
    <path d="M20 40V15" stroke={C} strokeWidth="1" strokeLinecap="round"/>
    <path d="M20 18C20 18 12 8 8 5" stroke={C} strokeWidth="1" strokeLinecap="round"/>
    <path d="M20 18C20 18 28 8 32 5" stroke={C} strokeWidth="1" strokeLinecap="round"/>
    <path d="M60 40V18" stroke={C} strokeWidth="1" strokeLinecap="round"/>
    <path d="M60 20C60 20 52 10 48 7" stroke={C} strokeWidth="1" strokeLinecap="round"/>
    <path d="M60 20C60 20 68 10 72 7" stroke={C} strokeWidth="1" strokeLinecap="round"/>
    <path d="M110 40V12" stroke={C} strokeWidth="1" strokeLinecap="round"/>
    <path d="M110 15C110 15 102 5 98 2" stroke={C} strokeWidth="1" strokeLinecap="round"/>
    <path d="M110 15C110 15 118 5 122 2" stroke={C} strokeWidth="1" strokeLinecap="round"/>
    <path d="M160 40V16" stroke={C} strokeWidth="1" strokeLinecap="round"/>
    <path d="M160 18C160 18 152 8 148 5" stroke={C} strokeWidth="1" strokeLinecap="round"/>
    <path d="M160 18C160 18 168 8 172 5" stroke={C} strokeWidth="1" strokeLinecap="round"/>
    <path d="M0 50C30 45 70 48 100 50C130 52 170 48 200 50" stroke={C} strokeWidth="1"/>
  </svg>
);

export const CashewLeaf = ({ className = "" }) => (
  <svg viewBox="0 0 60 80" fill="none" className={className} aria-hidden="true">
    <path d="M30 75V30" stroke={C} strokeWidth="2" strokeLinecap="round"/>
    <path d="M30 30C30 30 10 20 8 8C8 8 20 12 30 30Z" stroke={C} strokeWidth="1.5" strokeLinejoin="round"/>
    <path d="M30 30C30 30 50 20 52 8C52 8 40 12 30 30Z" stroke={C} strokeWidth="1.5" strokeLinejoin="round"/>
    <path d="M30 45C30 45 15 38 12 28" stroke={C} strokeWidth="1.2" strokeLinecap="round"/>
    <path d="M30 45C30 45 45 38 48 28" stroke={C} strokeWidth="1.2" strokeLinecap="round"/>
    <path d="M30 58C30 58 18 52 15 44" stroke={C} strokeWidth="1.2" strokeLinecap="round"/>
    <path d="M30 58C30 58 42 52 45 44" stroke={C} strokeWidth="1.2" strokeLinecap="round"/>
  </svg>
);

export const PalmLeaf = ({ className = "" }) => (
  <svg viewBox="0 0 90 120" fill="none" className={className} aria-hidden="true">
    <path d="M45 120V35" stroke={C} strokeWidth="2" strokeLinecap="round"/>
    <path d="M45 35C45 35 15 15 5 2" stroke={C} strokeWidth="1.8" strokeLinecap="round"/>
    <path d="M45 42C45 42 20 28 10 18" stroke={C} strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M45 50C45 50 25 40 15 32" stroke={C} strokeWidth="1.2" strokeLinecap="round"/>
    <path d="M45 35C45 35 75 15 85 2" stroke={C} strokeWidth="1.8" strokeLinecap="round"/>
    <path d="M45 42C45 42 70 28 80 18" stroke={C} strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M45 50C45 50 65 40 75 32" stroke={C} strokeWidth="1.2" strokeLinecap="round"/>
  </svg>
);

export const Farmer = ({ className = "" }) => (
  <svg viewBox="0 0 100 150" fill="none" className={className} aria-hidden="true">
    <ellipse cx="50" cy="10" rx="16" ry="6" stroke={C} strokeWidth="1.5"/>
    <circle cx="50" cy="18" r="10" stroke={C} strokeWidth="2"/>
    <path d="M50 28V60" stroke={C} strokeWidth="2"/>
    <path d="M50 38L30 55" stroke={C} strokeWidth="2" strokeLinecap="round"/>
    <path d="M50 38L70 50" stroke={C} strokeWidth="2" strokeLinecap="round"/>
    <path d="M70 50V20L85 15" stroke={C} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M85 15L88 8" stroke={C} strokeWidth="1.2" strokeLinecap="round"/>
    <path d="M85 15L92 12" stroke={C} strokeWidth="1.2" strokeLinecap="round"/>
    <path d="M85 15L88 22" stroke={C} strokeWidth="1.2" strokeLinecap="round"/>
    <path d="M50 60L35 105" stroke={C} strokeWidth="2" strokeLinecap="round"/>
    <path d="M50 60L65 105" stroke={C} strokeWidth="2" strokeLinecap="round"/>
    <path d="M50 55C42 55 38 58 38 60" stroke={C} strokeWidth="1.5"/>
    <path d="M50 55C58 55 62 58 62 60" stroke={C} strokeWidth="1.5"/>
    <path d="M5 115C20 108 40 108 60 115S90 118 95 115" stroke={C} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M10 130C15 120 20 118 25 120" stroke={C} strokeWidth="1" strokeLinecap="round"/>
    <path d="M40 128C45 118 50 116 55 118" stroke={C} strokeWidth="1" strokeLinecap="round"/>
    <path d="M70 130C75 120 80 118 85 120" stroke={C} strokeWidth="1" strokeLinecap="round"/>
  </svg>
);

export default {
  CoconutTree, Coconut, Crab, Fish, FishingBoat, Fisherman, Fisherwoman,
  Beach, OceanWaves, Seashell, Starfish, Hibiscus, Mango, ArecaNut,
  SindhudurgFort, Temple, Lighthouse, PaddyField, CashewLeaf, PalmLeaf, Farmer,
};
